/* EDIT SOFTSKILL COURSE */
export const MARK_SOFTSKILLS_NOTIFICATION = "MARK_SOFTSKILLS_NOTIFICATION"
export const MARK_SOFTSKILLS_NOTIFICATION_SUCCESS =
  "MARK_SOFTSKILLS_NOTIFICATION_SUCCESS"
export const MARK_SOFTSKILLS_NOTIFICATION_CLEAN =
  "MARK_SOFTSKILLS_NOTIFICATION_CLEAN"
export const MARK_SOFTSKILLS_NOTIFICATION_ERROR =
  "MARK_SOFTSKILLS_NOTIFICATION_ERROR"
